// R8-2 — THE JOURNAL TITLE, LIFTED OUT OF App.tsx VERBATIM.
//
// The comment below already states this component's whole reason for existing — "one component
// rather than a rule copied into each list, because there are already two lists and the quick-access
// one had truncation while My Room did not" — and nothing enforced it, because a leaf component
// inside a TSX file is unreachable from `scripts/`. It takes props, holds no state and calls no
// hook, which is the entry requirement, so `scripts/r8-leaves.mjs` CALLS it and reads the tree back:
// the shared class both lists key their truncation off, the FULL title on the element so CSS
// truncation never hides an entry's name from the member, and the untitled fallback that keeps an
// unnamed entry clickable.
//
// Moved VERBATIM.

// N1-3 — ONE journal title, everywhere one is shown. A long title used to run off the layout edge and
// look unclean (My Room was the worst: it had no truncation at all). It is now cut with an ellipsis at
// the edge WHEREVER it is listed, and the FULL title appears when the entry is expanded — so nothing is
// hidden from the member, it is just not allowed to break the room.
//
// One component rather than a rule copied into each list, because there are already two lists and the
// quick-access one had truncation while My Room did not — which is exactly how they drifted apart.
export function JournalTitle({ title, expanded, className }: { title?: string | null; expanded?: boolean; className?: string }) {
  const text = (title || "").trim() || "Untitled entry";
  return (
    <span className={`journal-title${expanded ? " is-open" : ""}${className ? ` ${className}` : ""}`} title={text}>
      {text}
    </span>
  );
}
